import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqs } from '@/mocks/articles';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('home.faq.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t('home.faq.subtitle')}
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.slice(0, 6).map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-2">
                  {faq.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-sm text-foreground-500">
            {t('home.faq.stillQuestions')}
            <a href="mailto:contact@caoliu-qrcode.example.com" className="text-primary-600 hover:text-primary-700 font-medium ml-1">
              联系我们
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}